import { Icon } from '@homebotapp/hb-react-component-catalog'
import { Text } from '../../..'

import styles from './FilterCheckBox.module.scss'

export interface FilterCheckBoxProps {
  name: string
  label: string
  isChecked: boolean
  onChange: (e) => void
  iconName?: string
  iconColor?: string
}

export const FilterCheckBox = ({ name, label, onChange, isChecked, iconName, iconColor }: FilterCheckBoxProps) => {
  return (
    <div className={styles.checkBox}>
      <input id={name} name={name} data-qa={name} type='checkbox' checked={isChecked} onChange={onChange} />
      <Text
        size='xs'
        align='center'
        htmlFor={name}
        element='label'
        weight='semibold'
        variantCount='900'
        variant='neutralCool'
        className={styles.label}
      >
        {iconName && iconColor && (
          <Icon
            mr={1}
            // @ts-ignore
            name={iconName}
            // @ts-ignore
            color={iconColor}
            borderRadius='full'
            border={isChecked ? '1px solid white' : 'none'}
          />
        )}
        {label}
      </Text>
    </div>
  )
}
